module.exports = "data:audio/mpeg;base64,"